const styles = {
  toggleBtn: {
    color: "#000",
  },
  features: {
    // height: '30vh',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    lineHeight: "25px",
    width: "100%",
  },
  homePara: {
    color: "gray",
    fontSize: "18px",
    letterSpacing: "1px",
    lineHeight: "30px",
  },
  choose: {
    fontSize: "35px",
    textTransform: "uppercase",
    letterSpacing: "1px",
  },
  aboutLayout: {
    paddingBottom: "80px",
    paddingTop: "80px",
  },
  aboutUs: {
    display: "flex",
    alignItems: "center",
  },
  aboutusDiv: {
    width: "100%",
    margin: "50px 0",
    padding: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  ourTeamDiv: {
    height: "20vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  galleryImg: {
    width: "100%",
    height: "40vh",
    objectFit: "cover",
  },
  label: {
    display: "block",
    fontSize: "18px",
    color: "#333",
    margin: "10px 0px",
  },
  mesInput: {
    border: "1px solid gray",
    borderRadius: "20px",
    width: "100%",
    fontSize: "16px",
  },
  mesTextArea: {
    border: "1px solid gray",
    borderRadius: "20px",
    padding: "5px 10px",
    fontSize: "16px",
    marginBottom: "10px",
    width: "100%",
  },
};

export default styles;
